module.exports = __webpack_public_path__ + "img/AboutS3.e5d63420.png";